import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'uil-home-alt',
        link: '/',
    },
    {
        id: 6,
        label: 'Orders',
        icon: 'uil-bolt-alt',
        subItems: [
            {
                id: 78,
                label: 'New Order',
                link: '/orders/new-order',
                parentId: 3
            },
            {
                id: 80,
                label: 'View Orders',
                link: '/orders/view-orders',
                parentId: 3
            },
        ]
    },
    {
        id: 6,
        label: 'Pattern Management',
        icon: 'uil-bolt-alt',
        subItems: [
   
            {
                id: 78,
                label: 'View',
                link: '/pattern-management/all-patterns',
                parentId: 3
            },
        ]
    },
    {
        id: 7,
        label: 'AW Management',
        icon: 'uil-shutter-alt',
        subItems: [
            {
                id: 78,
                label: 'View AW',
                link: '/po-details/view-all-vl',
                parentId: 7
            },
        ]
    },
];

